module.exports = __webpack_public_path__ + "./fonts/icomoon.bba09c.eot";